// Flow Mass units with conversion factors to kilogram-per-second (kg/s)
export const flowMassUnits = [
  { id: 'kilogram-per-second', name: 'Kilogram/Second', symbol: 'kg/s', plural: 'Kilograms/Second', toBase: 1 },
  { id: 'kilogram-per-minute', name: 'Kilogram/Minute', symbol: 'kg/min', plural: 'Kilograms/Minute', toBase: 1/60 },
  { id: 'kilogram-per-hour', name: 'Kilogram/Hour', symbol: 'kg/h', plural: 'Kilograms/Hour', toBase: 1/3600 },
  { id: 'kilogram-per-day', name: 'Kilogram/Day', symbol: 'kg/d', plural: 'Kilograms/Day', toBase: 1/86400 },
  { id: 'gram-per-second', name: 'Gram/Second', symbol: 'g/s', plural: 'Grams/Second', toBase: 0.001 },
  { id: 'gram-per-minute', name: 'Gram/Minute', symbol: 'g/min', plural: 'Grams/Minute', toBase: 0.001/60 },
  { id: 'gram-per-hour', name: 'Gram/Hour', symbol: 'g/h', plural: 'Grams/Hour', toBase: 0.001/3600 },
  { id: 'milligram-per-second', name: 'Milligram/Second', symbol: 'mg/s', plural: 'Milligrams/Second', toBase: 0.000001 },
  { id: 'milligram-per-minute', name: 'Milligram/Minute', symbol: 'mg/min', plural: 'Milligrams/Minute', toBase: 0.000001/60 },
  { id: 'pound-per-second', name: 'Pound/Second', symbol: 'lb/s', plural: 'Pounds/Second', toBase: 0.45359237 },
  { id: 'pound-per-minute', name: 'Pound/Minute', symbol: 'lb/min', plural: 'Pounds/Minute', toBase: 0.45359237/60 },
  { id: 'pound-per-hour', name: 'Pound/Hour', symbol: 'lb/h', plural: 'Pounds/Hour', toBase: 0.45359237/3600 },
  { id: 'ton-per-hour', name: 'Ton/Hour', symbol: 't/h', plural: 'Tons/Hour', toBase: 1000/3600 },
  { id: 'ton-per-day', name: 'Ton/Day', symbol: 't/d', plural: 'Tons/Day', toBase: 1000/86400 },
];

export const popularFlowMassConversions = [
  { from: 'kilogram-per-second', to: 'kilogram-per-hour' },
  { from: 'kilogram-per-hour', to: 'kilogram-per-second' },
  { from: 'kilogram-per-second', to: 'gram-per-second' },
  { from: 'gram-per-second', to: 'kilogram-per-second' },
  { from: 'pound-per-second', to: 'kilogram-per-second' },
  { from: 'ton-per-hour', to: 'kilogram-per-second' },
];

export const getUnitById = (id) => flowMassUnits.find(unit => unit.id === id);

export const convertFlowMass = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert mass flow rate units and learn the conversion formula.`;
};
